<div class="projekte-container">

  <!-- HEADER -->
  <div class="page-header">
    <h1 class="page-title">Projekte</h1>

    <div class="header-actions">

      <mat-button-toggle-group [value]="ansicht" (change)="ansicht = $event.value" aria-label="Ansicht umschalten">

        <mat-button-toggle value="kacheln" matTooltip="Kachelansicht">

          <mat-icon>grid_view</mat-icon>

        </mat-button-toggle>

        <mat-button-toggle value="liste" matTooltip="Listenansicht">

          <mat-icon>view_list</mat-icon>

        </mat-button-toggle>

      </mat-button-toggle-group>


      <button mat-raised-button color="primary" type="button" *ngIf="!formOpen && canCreateProjekt"
        (click)="neuesProjekt()">

        <mat-icon>add</mat-icon>
        Neues Projekt

      </button>

    </div>
  </div>


  <!-- FORMULAR -->
  <mat-card class="form-card" *ngIf="formOpen">

    <mat-card-content>

      <h2 class="form-title">
        Neues Projekt anlegen
      </h2>


      <div class="form-grid">

        <!-- PROJEKTNAME -->
        <mat-form-field appearance="outline">

          <mat-label>
            Projektname
          </mat-label>

          <input matInput [(ngModel)]="form.name" [disabled]="saving" placeholder="z.B. Erweiterung Kesselhaus">

        </mat-form-field>


        <!-- PROJEKTNUMMER -->
        <mat-form-field appearance="outline">

          <mat-label>
            Projektnummer
          </mat-label>

          <input matInput [(ngModel)]="form.projektNummer" [disabled]="saving" placeholder="z.B. P-2026-014">

          <mat-hint>
            Muss eindeutig sein.
          </mat-hint>

        </mat-form-field>


        <!-- KUNDE -->
        <mat-form-field appearance="outline">

          <mat-label>
            Kunde (optional)
          </mat-label>

          <!--
            Der Kunde ist kein Pflichtfeld: zu Projektbeginn steht oft noch
            nicht fest, für wen gearbeitet wird. Ein Projekt ohne Kunden
            unterliegt keiner Kundeneinschränkung und ist damit für jeden
            sichtbar, der den Projektbereich sehen darf.
          -->
          <mat-select [value]="form.customerId || null" (selectionChange)="onKundeChange($event.value)"
            [disabled]="saving">

            <mat-option [value]="null">
              — kein Kunde —
            </mat-option>

            <mat-option *ngFor="let k of kunden" [value]="k.id">

              {{ k.name }}

            </mat-option>

          </mat-select>

          <mat-hint *ngIf="kunden.length === 0">
            Es sind keine Kunden vorhanden.
          </mat-hint>

        </mat-form-field>


        <!-- ANLAGE -->
        <mat-form-field appearance="outline">

          <mat-label>
            Anlage (optional)
          </mat-label>

          <mat-select [(ngModel)]="form.equipmentId" [disabled]="saving || !form.customerId || loadingAnlagen">

            <mat-option [value]="null">
              — keine —
            </mat-option>

            <mat-option *ngFor="let a of anlagen" [value]="a.id">

              {{ a.name }}

              <span class="anlage-ort" *ngIf="a.location">

                · {{ a.location }}

              </span>

            </mat-option>

          </mat-select>


          <!--
            Eine Anlage gehört immer einem Kunden. Ohne Kunden am Projekt
            wäre die Zuordnung widersprüchlich, deshalb bleibt das Feld
            gesperrt statt eine unpassende Auswahl anzubieten.
          -->
          <mat-hint *ngIf="!form.customerId">
            Nur mit zugeordnetem Kunden wählbar.
          </mat-hint>

          <mat-hint *ngIf="form.customerId && loadingAnlagen">
            Anlagen werden geladen …
          </mat-hint>

          <mat-hint *ngIf="
              form.customerId
              && !loadingAnlagen
              && anlagen.length === 0
            ">

            Für diesen Kunden ist keine Anlage hinterlegt.

          </mat-hint>

        </mat-form-field>

        <!-- PROJEKTZUGRIFF -->
        <mat-form-field appearance="outline" class="zugriff-field">

          <mat-label>
            Projektzugriff
          </mat-label>

          <mat-select [(ngModel)]="form.userIds" multiple [disabled]="
      saving
      || loadingZugriffsBenutzer
    ">

            <mat-option *ngFor="let user of zugriffsBenutzer" [value]="user.id">

              {{ user.userName || user.email }}

              <span *ngIf="
          user.email
          && user.email !== user.userName
        " class="user-email">

                · {{ user.email }}

              </span>

            </mat-option>

          </mat-select>


          <mat-hint *ngIf="loadingZugriffsBenutzer">

            Benutzer werden geladen …

          </mat-hint>


          <mat-hint *ngIf="
      !loadingZugriffsBenutzer
      && zugriffsBenutzer.length === 0
      && !zugriffsBenutzerError
    ">

            Keine zuweisbaren Benutzer vorhanden.

          </mat-hint>


          <mat-hint *ngIf="
      !loadingZugriffsBenutzer
      && !zugriffsBenutzerError
      && zugriffsBenutzer.length > 0
    ">

            {{ form.userIds.length }} Benutzer ausgewählt.

          </mat-hint>

        </mat-form-field>

        <p class="form-error" *ngIf="zugriffsBenutzerError">

          <mat-icon>
            error_outline
          </mat-icon>

          {{ zugriffsBenutzerError }}

        </p>

      </div>


      <!-- FORMULARFEHLER -->
      <p class="form-error" *ngIf="formError">

        <mat-icon>
          error_outline
        </mat-icon>

        {{ formError }}

      </p>


      <!-- FORMULAR-AKTIONEN -->
      <div class="form-actions">

        <button mat-button type="button" [disabled]="saving" (click)="abbrechen()">

          Abbrechen

        </button>


        <button mat-raised-button color="primary" type="button" [disabled]="!istGueltig || saving"
          (click)="speichern()">

          <mat-spinner diameter="18" *ngIf="saving">
          </mat-spinner>

          <span *ngIf="!saving">
            Anlegen
          </span>

        </button>

      </div>

    </mat-card-content>

  </mat-card>


  <!-- LADEN -->
  <div class="loading" *ngIf="isLoading">

    <mat-spinner diameter="40">
    </mat-spinner>

  </div>


  <!-- FEHLER -->
  <mat-card class="hint-card" *ngIf="loadError">

    <mat-card-content>
      {{ loadError }}
    </mat-card-content>

  </mat-card>


  <!-- OHNE VERBINDUNG: nur heruntergeladene Projekte, aber mit demselben Weg wie online -->
  <mat-card class="offline-hinweis" *ngIf="istOffline && !isLoading && !loadError">

    <mat-card-content>
      <mat-icon>cloud_off</mat-icon>
      <span>
        Keine Verbindung zum Server. Angezeigt werden die Projekte, die auf diesem Gerät
        offline verfügbar sind – sie lassen sich wie gewohnt öffnen und prüfen.
      </span>
    </mat-card-content>

  </mat-card>


  <!-- ÜBERSICHT -->
  <mat-card class="table-card" *ngIf="!isLoading && !loadError">

    <mat-card-content>


      <!-- ========================================== -->
      <!-- FILTER -->
      <!-- ========================================== -->

      <div class="filter-bar">

        <!-- SUCHE -->
        <mat-form-field appearance="outline" class="search-field">

          <mat-label>
            Projekte durchsuchen
          </mat-label>

          <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilter()"
            placeholder="Nummer, Name, Kunde, Anlage …">

          <mat-icon matPrefix>
            search
          </mat-icon>

        </mat-form-field>


        <!-- KUNDE -->
        <mat-form-field appearance="outline" class="filter-field">

          <mat-label>
            Kunde
          </mat-label>

          <mat-select [(ngModel)]="selectedCustomer" (selectionChange)="applyFilter()">

            <mat-option value="">
              Alle Kunden
            </mat-option>

            <mat-option *ngFor="let kunde of kunden" [value]="kunde.name">

              {{ kunde.name }}

            </mat-option>

          </mat-select>

        </mat-form-field>


        <!-- STATUS -->
        <mat-form-field appearance="outline" class="filter-field">

          <mat-label>
            Status
          </mat-label>

          <mat-select [(ngModel)]="selectedStatus" (selectionChange)="applyFilter()">

            <mat-option value="alle">
              Alle
            </mat-option>

            <mat-option value="nichtGestartet">
              Nicht gestartet
            </mat-option>

            <mat-option value="offen">
              Offen
            </mat-option>

            <mat-option value="geprueft">
              Geprüft
            </mat-option>

          </mat-select>

        </mat-form-field>


        <!-- FILTER ZURÜCKSETZEN -->
        <button mat-stroked-button type="button" class="reset-filter" *ngIf="
            searchTerm
            || selectedCustomer
            || selectedStatus !== 'alle'
          " (click)="clearFilter()">

          <mat-icon>
            filter_alt_off
          </mat-icon>

          Zurücksetzen

        </button>

      </div>


      <!-- KEINE PROJEKTE -->
      <p class="empty-hint" *ngIf="dataSource.data.length === 0">

        Es ist noch kein Projekt angelegt.

      </p>


      <!-- KEINE FILTERERGEBNISSE -->
      <p class="empty-hint" *ngIf="
          dataSource.data.length > 0
          && dataSource.filteredData.length === 0
        ">

        Kein Projekt passt zu den gewählten Filtern.

      </p>


      <!-- ========================================== -->
      <!-- KACHELN -->
      <!-- ========================================== -->

      <div class="kachel-grid" *ngIf="
          ansicht === 'kacheln'
          && dataSource.filteredData.length > 0
        ">

        <div class="kachel" *ngFor="
            let p of dataSource.filteredData;
            trackBy: trackByProjekt
          " [class.kachel-fertig]="istFertig(p)" [class.kachel-offen]="istOffen(p)"
          [class.kachel-nicht-gestartet]="istNichtGestartet(p)" (click)="oeffnen(p)" matTooltip="Projekt öffnen">


          <!-- KACHEL HEADER -->
          <div class="kachel-head">

            <span class="kachel-nummer">
              {{ p.projektNummer }}
            </span>

            <span class="status-badge" [class.status-badge-fertig]="istFertig(p)"
              [class.status-badge-offen]="istOffen(p)" [class.status-badge-nicht-gestartet]="istNichtGestartet(p)">
              {{ statusText(p) }}
            </span>

          </div>


          <!-- TITEL -->
          <span class="kachel-titel">
            {{ p.name }}
          </span>


          <!-- OFFLINE-ZUSTAND: nur bei heruntergeladenen Projekten -->
          <span class="status-badge kachel-offline" [ngClass]="offlineKlasse(p)" *ngIf="offlineVon(p)"
            [matTooltip]="offlineVon(p)?.lastSyncAtUtc
              ? 'Zuletzt synchronisiert: ' + (offlineVon(p)?.lastSyncAtUtc | date:'dd.MM.yyyy HH:mm')
              : 'Auf diesem Gerät offline verfügbar'">
            <mat-icon inline>{{ offlineIcon(p) }}</mat-icon>
            {{ offlineText(p) }}
          </span>


          <!-- META -->
          <div class="kachel-meta">

            <span>

              <mat-icon inline>
                business
              </mat-icon>

              {{ p.customerName || '–' }}

            </span>


            <span *ngIf="p.equipmentName">

              <mat-icon inline>
                precision_manufacturing
              </mat-icon>

              {{ p.equipmentName }}

            </span>

          </div>


          <!-- FORTSCHRITT -->
          <div class="kachel-progress" *ngIf="p.messstellenGesamt > 0">

            <mat-progress-bar mode="determinate" [value]="fortschritt(p)">
            </mat-progress-bar>

            <span class="kachel-progress-text">
              {{ p.messstellenGestartet }} / {{ p.messstellenGesamt }} Messstellen gestartet
              · {{ p.messstellenAbgeschlossen }} / {{ p.messstellenGesamt }} geprüft
              · {{ fortschritt(p) }} %
            </span>

            <span class="kachel-progress-sub" *ngIf="p.pruefpunkteGesamt > 0">
              {{ p.pruefpunkteErledigt }} / {{ p.pruefpunkteGesamt }} vorhandene Prüfpunkte abgearbeitet
            </span>

          </div>


          <span class="kachel-keine" *ngIf="p.messstellenGesamt === 0">
            Noch keine Messstellen vorhanden.
          </span>


          <!-- FOOTER -->
          <div class="kachel-fuss">

            {{ p.inbetriebnahmenCount }}

            Inbetriebnahme{{ p.inbetriebnahmenCount === 1 ? '' : 'n' }}

            ·

            {{ p.messstellenGesamt }}

            Messstellen

          </div>

        </div>

      </div>


      <!-- ========================================== -->
      <!-- LISTE -->
      <!-- ========================================== -->

      <div class="table-scroll" *ngIf="ansicht === 'liste'" [hidden]="dataSource.filteredData.length === 0">


        <table mat-table [dataSource]="dataSource" [trackBy]="trackByProjekt">


          <!-- PROJEKTNUMMER -->
          <ng-container matColumnDef="projektNummer">

            <th mat-header-cell *matHeaderCellDef>

              Projektnummer

            </th>

            <td mat-cell *matCellDef="let p" class="nummer-zelle">

              {{ p.projektNummer }}

            </td>

          </ng-container>


          <!-- PROJEKTNAME -->
          <ng-container matColumnDef="name">

            <th mat-header-cell *matHeaderCellDef>

              Projektname

            </th>

            <td mat-cell *matCellDef="let p">

              {{ p.name }}

            </td>

          </ng-container>


          <!-- KUNDE -->
          <ng-container matColumnDef="customerName">

            <th mat-header-cell *matHeaderCellDef>

              Kunde

            </th>

            <td mat-cell *matCellDef="let p">

              {{ p.customerName || '–' }}

            </td>

          </ng-container>


          <!-- ANLAGE -->
          <ng-container matColumnDef="equipmentName">

            <th mat-header-cell *matHeaderCellDef>

              Anlage

            </th>

            <td mat-cell *matCellDef="let p">

              <span *ngIf="p.equipmentName">
                {{ p.equipmentName }}
              </span>

              <span class="leer" *ngIf="!p.equipmentName">

                –

              </span>

            </td>

          </ng-container>


          <!-- STATUS -->
          <ng-container matColumnDef="status">

            <th mat-header-cell *matHeaderCellDef class="status-col">

              Status

            </th>


            <td mat-cell *matCellDef="let p" class="status-col">

              <div class="status-zelle">

                <div class="status-topline">
                  <span class="status-badge" [class.status-badge-fertig]="istFertig(p)"
                    [class.status-badge-offen]="istOffen(p)"
                    [class.status-badge-nicht-gestartet]="istNichtGestartet(p)">
                    {{ statusText(p) }}
                  </span>

                  <span class="status-zahlen">
                    {{ p.inbetriebnahmenCount }} IBN · {{ p.messstellenGesamt }} Messst.
                  </span>

                  <span class="status-badge" [ngClass]="offlineKlasse(p)" *ngIf="offlineVon(p)"
                    [matTooltip]="offlineVon(p)?.lastSyncAtUtc
                      ? 'Zuletzt synchronisiert: ' + (offlineVon(p)?.lastSyncAtUtc | date:'dd.MM.yyyy HH:mm')
                      : 'Auf diesem Gerät offline verfügbar'">
                    <mat-icon inline>{{ offlineIcon(p) }}</mat-icon>
                    {{ offlineText(p) }}
                  </span>
                </div>

                <div class="status-progress" *ngIf="p.messstellenGesamt > 0">
                  <mat-progress-bar mode="determinate" [value]="fortschritt(p)">
                  </mat-progress-bar>

                  <span class="status-prozent" [class.fertig]="istFertig(p)">
                    {{ fortschritt(p) }} %
                  </span>
                </div>

                <span class="status-detail" *ngIf="p.messstellenGesamt > 0">
                  {{ p.messstellenGestartet }} / {{ p.messstellenGesamt }} gestartet
                  · {{ p.messstellenAbgeschlossen }} / {{ p.messstellenGesamt }} geprüft
                </span>

                <span class="kachel-keine" *ngIf="p.messstellenGesamt === 0">
                  Noch keine Messstellen vorhanden.
                </span>

              </div>

            </td>

          </ng-container>


          <!-- HEADER -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
          </tr>


          <!-- ZEILE -->
          <tr mat-row *matRowDef="
              let row;
              columns: displayedColumns;
            " class="clickable-row" (click)="oeffnen(row)" matTooltip="Projekt öffnen">
          </tr>

        </table>

      </div>

    </mat-card-content>

  </mat-card>

</div>